import { render, staticRenderFns } from "./giftGoodsList.vue?vue&type=template&id=02556712&scoped=true"
import script from "./giftGoodsList.vue?vue&type=script&lang=js"
export * from "./giftGoodsList.vue?vue&type=script&lang=js"
import style0 from "./giftGoodsList.vue?vue&type=style&index=0&id=02556712&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02556712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02556712')) {
      api.createRecord('02556712', component.options)
    } else {
      api.reload('02556712', component.options)
    }
    module.hot.accept("./giftGoodsList.vue?vue&type=template&id=02556712&scoped=true", function () {
      api.rerender('02556712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/fullGift/components/giftGoodsList.vue"
export default component.exports